import { Badge } from 'reactstrap'
import useTranslation from '../hooks/UseTranslation'

const ParticipantsBadge = ({ listing }) => {
  const { t } = useTranslation()
  const hasSpace = listing.num_participants < listing.max_participants
  const color = hasSpace ? 'primary-light' : 'light'
  const text = hasSpace
    ? t(
        'listing_has_spot_left',
        listing.max_participants - listing.num_participants
      )
    : t('listing_has_no_spot_left')
  return (
    <>
      <Badge
        className='d-none d-sm-inline-block'
        color={color}
        style={{ marginRight: '5px' }}
      >
        <i className='fas fa-users fa-fw text-primary mr-2' />
        {text}
      </Badge>
      <Badge
        className='d-sm-none d-inline-block'
        color={color}
        style={{ marginRight: '5px' }}
      >
        <i className='fas fa-users fa-fw text-primary mr-2' />
        {`${listing.num_participants}/${listing.max_participants}`}
      </Badge>
    </>
  )
}

export default ParticipantsBadge
